
<v-container class="productContainer">
  <v-row>
    <v-col cols="auto">
      <v-btn class="backButton" @click="$router.go(-1)">
        <v-icon class="buttonIcon">arrow_back</v-icon>
        {{ $t("BUTTON_BACK_TO_PRODUCTS") }}
      </v-btn>
    </v-col>
  </v-row>
  <v-row wrap class="layout">
    <v-col cols="12" md="6">
      <v-img :src="product.imageUrl" class="productImage" contain></v-img>
    </v-col>
    <v-col cols="12" md="6">
      <v-row v-show="error || showAlert > 0">
        <v-col cols="12">
          <v-alert type="success" :v-show="showAlert > 0" transition="fade-transition" class="addedToBasketAlert">
            {{ $t("PRODUCT_ADDED_TO_BASKET") }}
            <router-link to="/basket" class="basketLink">{{ $t("GO_TO_BASKET") }}</router-link>
          </v-alert>
          <v-alert type="error" v-show="error" transition="fade-transition" class="addedToBasketAlert">{{
              error
            }}
          </v-alert>
        </v-col>
      </v-row>
      <div class="productDetails elevation-3">
        <v-row align-center class="header">
          <v-col cols="auto">
            <h1 class="display-1">{{ product.name }}</h1>
          </v-col>
          <v-spacer/>
          <v-col v-if="hasDiscount" cols="auto">
            <h3 class="priceTag instead">{{ formatPrice(product.setPriceInsteadOf) }}</h3>
          </v-col>
          <v-col cols="auto">
            <h3 :class="{priceTag: true, discounted: hasDiscount}">{{ formatPrice(price) }}</h3>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <h3 class="subHeading grey--text">{{ product.subHeading }}</h3>
          </v-col>
        </v-row>
        <br>
        <v-row class="description">
          <v-col>
            <p v-html="product.longDescription"></p>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer/>
          <v-col cols="auto">
            <v-btn color="primary" @click="startConfiguration">{{ $t("BUTTON_CONFIGURE_PRODUCT") }}</v-btn>
          </v-col>
          <v-spacer/>
        </v-row>
        <v-dialog v-model="configuring" content-class="configuratorDialog" scrollable>
          <v-icon @click="configuring = false" class="closeDialog">close</v-icon>
          <ProductConfigurator :product="product" @addedToBasket="addedToBasket" @error="onConfigurationError"/>
        </v-dialog>
        <!--<v-card class="filterContainer" v-show="hasImages && product.medium !== 'DOWNLOAD' && product.productType !== 'SET' && !product.imageFilter">
          <v-card-title>
            <h4 class="title">{{ $t("FILTER_SELECTION_HEADER") }}</h4>
          </v-card-title>
          <v-card-text>{{ $t("FILTER_SELECTION_TEXT") }}</v-card-text>
          <div class="content">
            <v-select
                v-model="filter"
                :items="availableFilters"
                item-value="id"
                item-text="name"/>
          </div>
        </v-card>-->
        <!-- v-row row wrap>
          <v-btn to="/" :color="continueShopping ? 'primary' : null">
            <v-icon class="buttonIcon">arrow_back</v-icon>
            {{ $t("BUTTON_CONTINUE_SHOPPING") }}
          </v-btn>
          <v-spacer/>
          <v-tooltip top :disabled="isValid">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn :disabled="! isValid" @click="addToBasket" color="primary">
                  <v-icon class="buttonIcon">shopping_cart</v-icon>
                  {{ $t("BUTTON_ADD_TO_BASKET") }}
                </v-btn>
              </div>
            </template>
            <span>{{ $t("IMAGE_CHOOSE_ERROR") }}</span>
          </v-tooltip>
        </v-row-->
      </div>
    </v-col>
  </v-row>
</v-container>
